import * as React from 'react';
import { NavLink } from 'react-router-dom';

interface IMenuLinkProps {
  to: string;
  label: string;
}

export default function MenuLink(props: IMenuLinkProps) {
  return (
    <li className="nav-item">
      <NavLink to={props.to} className="nav-link" activeClassName="active">
        {props.label}
      </NavLink>
    </li>
  )
}


// WEBPACK FOOTER //
// ./src/MenuLink.tsx